import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import './styles.scss';

const DropdownButton = forwardRef((props, fRef) => {
    const ref = useRef();

    const [isOpen, toggleDropdown] = useState(false);

    useOnClickOutside(ref, () => toggleDropdown(false));

    useImperativeHandle(fRef, () => ({
      hideDropDown: () => toggleDropdown(false)
    }));
  
    return (
        <div className={classNames({
            'dropdown-button': true,
            'dropdown-button--is-open': isOpen,
            ...props.modifiers
        })} ref={ref}>
            <button 
                type="button" 
                onClick={() => toggleDropdown(!isOpen)}
                className={classNames({
                  'dropdown-button__button': true,
                  ...props.buttonModifiers
                })}
                aria-expanded={isOpen}
                aria-controls={props.controls}>
                {props.buttonChildren}
            </button>
            <ul id={props.controls}
                aria-hidden={!props.isOpen}
                className="dropdown-button__menu">
                    {props.children}                
            </ul>
        </div>
    );
});

const useOnClickOutside = (ref, handler) => {
  useEffect(
    () => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

export default DropdownButton;